module.exports = __webpack_public_path__ + "images/m-interface_apple@3x-b24d50.png";